import { storeAction } from "./immersetup";
import { getEntityField as getStateEntityField, setEntityField as setStateEntityField, setStateField as setStateRootField } from "./setfield";
var createEntityFieldGetter = function (state) {
    return function (field) {
        return getStateEntityField(state, field);
    };
};
function setStateField(field, value, validator, storeInvalidValue) {
    if (validator === void 0) { validator = null; }
    if (storeInvalidValue === void 0) { storeInvalidValue = true; }
    return storeAction(function (draft) {
        setStateRootField(draft, field, value, validator, storeInvalidValue);
    });
}
function setEntityField(field, value, validator, storeInvalidValue) {
    if (validator === void 0) { validator = null; }
    if (storeInvalidValue === void 0) { storeInvalidValue = true; }
    return storeAction(function (draft) {
        setStateEntityField(draft, field, value, validator, storeInvalidValue);
    });
}
export { createEntityFieldGetter, setEntityField, setStateField, };
